import findKey from 'lodash/findKey';
import config, { TTenantConfigKey } from '@/dataroom/app/config/config';

import { IDataroomTenantConfig } from '@/dataroom/domain/vo/DataroomTenantConfig';
import isServer from '@framework/router/Next/isServer';

// The constructor copies the whole tenant config onto the instance, so an instance really
// does carry every IDataroomTenantConfig field. Declaration merging states that once, instead
// of an `as IDataroomTenantConfig` assertion on every return.
interface DataroomTenantConfig extends IDataroomTenantConfig {}

class DataroomTenantConfig {
  constructor(tenantConfig: IDataroomTenantConfig) {
    Object.assign(this, tenantConfig);
  }

  static fromCode(code: string) {
    const tenantKey = findKey(
      config.tenant,
      (tenant: IDataroomTenantConfig) => tenant.code === code,
    ) as TTenantConfigKey | undefined;

    if (typeof tenantKey === 'undefined') {
      throw new Error(`Tenant ${ code } not found`);
    }

    return new DataroomTenantConfig(config.tenant[tenantKey]);
  }

  static fromHostname(hostname: string = isServer() ? undefined! : window.location.hostname) {
    if (!this.exists(hostname)) {
      throw new Error(`Tenant not found, hostname: ${ hostname }`);
    }

    return new DataroomTenantConfig(
      config.tenant[findKey(config.tenant, (tenant) => tenant.hostname === hostname) as TTenantConfigKey],
    );
  }

  static fromObject(object: IDataroomTenantConfig) {
    return new DataroomTenantConfig(object);
  }

  static exists(hostname: string = isServer() ? undefined! : window.location.hostname) {
    return !!config.tenant[findKey(config.tenant, (tenant) => tenant.hostname === hostname) as TTenantConfigKey];
  }
}

export default DataroomTenantConfig;
